import { MdInfo, MdOutlineWarning } from "react-icons/md";
import InfoBlock from "../InfoBlock/InfoBlock";
import { ICON_SIZES } from "src/helpers/constants";
import { formatLongDate } from "src/helpers/utils";
import moment from "moment";
import { useMemo } from "react";
import { IButton } from "../Button/Button";
import clsx from "clsx";

interface IRecurringTransactionInfo {
  settings: any;
  buttons?: IButton[];
}

const RecurringTransactionInfo: React.FC<IRecurringTransactionInfo> = ({
  settings,
  buttons,
}) => {
  const nextPayment = moment(settings?.nextPayment);
  const isOverdue = nextPayment.diff(moment(), "days") < 0;

  const message = useMemo(() => {
    if (isOverdue) {
      return `La transacción debía efectuarse el ${formatLongDate(
        nextPayment.toString()
      )}.`;
    } else if (
      moment().format("yyyy-MM-DD") === nextPayment.format("yyyy-MM-DD")
    ) {
      return `La próxima transacción es HOY.`;
    }

    return `La próxima transacción es el ${formatLongDate(
      nextPayment.toString()
    )}.`;
  }, [settings]);

  return (
    <InfoBlock
      title="Transacción recurrente"
      message={message}
      buttons={buttons}
      displayMobileIcon
      icon={
        isOverdue ? (
          <MdOutlineWarning
            size={ICON_SIZES.MD}
            className={clsx(["dark:text-yellow-300", "text-red-500"])}
          />
        ) : (
          <MdInfo size={ICON_SIZES.MD} />
        )
      }
    />
  );
};

export default RecurringTransactionInfo;
